import {CSSProperties, ReactNode} from 'react';
import {Link, LinkProps} from 'react-router-dom';
import {Button, ButtonProps} from '@/components/app/button';
import {cn} from '@/lib/utils';
import {Icon, IconProp} from '../Icon';
import styles from './InfoSection.module.css';
export type InfoSectionAction =
  | {
      props: ButtonProps;
      type: 'button';
      visible?: boolean;
    }
  | {
      props: LinkProps;
      type: 'link';
      visible?: boolean;
    };
export interface InfoSectionProps {
  actions?: InfoSectionAction[];
  className?: string;
  content?: ReactNode;
  contentClassName?: string;
  footerClassName?: string;
  icon?: IconProp;
  iconClassName?: string;
  message?: ReactNode;
  messageClassName?: string;
  style?: CSSProperties;
  subtitle?: ReactNode;
  subtitleClassName?: string;
  title?: ReactNode;
  titleClassName?: string;
}
export const InfoSection = ({
  actions,
  className,
  content,
  contentClassName,
  footerClassName,
  icon,
  iconClassName,
  message,
  messageClassName,
  style,
  subtitle,
  subtitleClassName,
  title,
  titleClassName,
}: InfoSectionProps) => {
  const headerVisible = !!icon || !!title || !!subtitle;
  const bodyVisible = !!content || !!message;
  const footerVisible = !!actions?.filter((action) => action.visible !== false).length;
  return (
    <section className={cn(styles.infoSection, className)} style={style}>
      {headerVisible && (
        <header className={styles.header}>
          {icon && <Icon className={cn(styles.icon, iconClassName)} icon={icon} />}
          {title && <h1 className={cn(styles.title, titleClassName)}>{title}</h1>}
          {subtitle && <p className={cn(styles.subtitle, subtitleClassName)}>{subtitle}</p>}
        </header>
      )}
      {bodyVisible && (
        <div className={styles.body}>
          {message && <p className={cn(styles.message, messageClassName)}>{message}</p>}
          {content && <div className={cn(styles.content, contentClassName)}>{content}</div>}
        </div>
      )}
      {footerVisible && (
        <footer className={cn(styles.footer, footerClassName)}>
          {actions
            ?.filter((action) => action.visible !== false)
            .map((action, index) =>
              action.type === 'button' ? (
                <Button {...action.props} key={index} type="button" />
              ) : action.type === 'link' ? (
                <Link {...action.props} key={index} />
              ) : null,
            )}
        </footer>
      )}
    </section>
  );
};
